// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryBlog_container__JpvFl {
    width: 100%;
}
  
  .CategoryBlog_hero__oelPj {
    background: linear-gradient(to right, #2c3e50, #3498db);
    padding: 7rem 1rem;
    margin-bottom: 2rem;
}
  
  .CategoryBlog_heroTitle__TTRi8 {
    color: white;
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  }
  
  .CategoryBlog_blogGrid__xbF8v {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 2rem;
    padding: 1rem;
  }
  
  .CategoryBlog_blogCard__5xJiA {
    background: rgb(0, 0, 0);
    border-radius: 1rem;
    overflow: hidden;
    box-shadow: 0px 1px 4px 6px rgba(93, 106, 156, 0.135);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  
  .CategoryBlog_blogCard__5xJiA:hover {
    transform: translateY(-4px);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }
  
  .CategoryBlog_imageWrapper__eUYz8 {
    position: relative;
    aspect-ratio: 16 / 9;
  }
  
  .CategoryBlog_cardImage__oQ5Nz {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .CategoryBlog_category__NPECS {
    position: absolute;
    left: 1rem;
    top: 1rem;
    background: rgba(0, 0, 0, 0.75);
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 2rem;
    font-size: 0.875rem;
    font-weight: 500;
  }
  
  .CategoryBlog_likeButton__Q4PLA {
    position: absolute;
    right: 1rem;
    top: 1rem;
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 50%;
    width: 2.5rem;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: transform 0.2s ease;
  }
  
  .CategoryBlog_likeButton__Q4PLA:hover {
    transform: scale(1.1);
  }
  
  .CategoryBlog_heartIcon__LmiWk {
    color: #e74c3c;
  }
  
  .CategoryBlog_cardContent__b4UYt {
    padding: 1.5rem;
  }
  
  .CategoryBlog_authorInfo__BgyvL {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }
  
  .CategoryBlog_author__doFCK {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  
  .CategoryBlog_avatarCircle__hYx99 {
    width: 2.5rem;
    height: 2.5rem;
    background: #f0f0f0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    color: #666;
  }
  
  .CategoryBlog_authorName__IN5J4 {
    font-weight: 500;
    color: #fff2f2;
  }
  
  .CategoryBlog_date__XqXit {
    color: #ffffff;
    font-size: 0.875rem;
  }
  
  .CategoryBlog_cardTitle__OYGIO {
    font-size: 1.25rem;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 0.75rem;
    line-height: 1.4;
  }
  
  .CategoryBlog_cardDescription__GkpyW {
    color: #fff9f9;
    line-height: 1.6;
    margin-bottom: 1rem;
  }
  
  .CategoryBlog_authorSignature__8QpLa {
    display: block;
    color: #b10b0b;
    font-size: 0.875rem;
    font-style: italic;
  }
  
  @media (max-width: 768px) {
    .CategoryBlog_hero__oelPj {
      padding: 3rem 1rem;
    }
    
    .CategoryBlog_heroTitle__TTRi8 {
      font-size: 2rem;
    }
    
    .CategoryBlog_blogGrid__xbF8v {
      grid-template-columns: 1fr;
    }
  }
  
  @media (max-width: 480px) {
    .CategoryBlog_hero__oelPj {
      padding: 2rem 1rem;
    }
    
    .CategoryBlog_heroTitle__TTRi8 {
      font-size: 1.5rem;
    }
    
    .CategoryBlog_cardContent__b4UYt {
      padding: 1rem;
    }
  }
  .CategoryBlog_learnMore__cMzwZ {
    color: #e41138;
    font-weight: 500;
    cursor: pointer;
  }`, "",{"version":3,"sources":["webpack://./src/Blogs/Components/CSS/CategoryBlog.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;EAEE;IACE,uDAAuD;IACvD,kBAAkB;IAClB,mBAAmB;AACvB;;EAEE;IACE,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,aAAa;EACf;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,qDAAqD;IACrD,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,+BAA+B;IAC/B,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,+BAA+B;EACjC;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,aAAa;IACf;EACF;EACA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;EACjB","sourcesContent":[".container {\n    width: 100%;\n}\n  \n  .hero {\n    background: linear-gradient(to right, #2c3e50, #3498db);\n    padding: 7rem 1rem;\n    margin-bottom: 2rem;\n}\n  \n  .heroTitle {\n    color: white;\n    font-size: 2.5rem;\n    font-weight: 700;\n    text-align: center;\n    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);\n  }\n  \n  .blogGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 2rem;\n    padding: 1rem;\n  }\n  \n  .blogCard {\n    background: rgb(0, 0, 0);\n    border-radius: 1rem;\n    overflow: hidden;\n    box-shadow: 0px 1px 4px 6px rgba(93, 106, 156, 0.135);\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n  }\n  \n  .blogCard:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n  }\n  \n  .imageWrapper {\n    position: relative;\n    aspect-ratio: 16 / 9;\n  }\n  \n  .cardImage {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .category {\n    position: absolute;\n    left: 1rem;\n    top: 1rem;\n    background: rgba(0, 0, 0, 0.75);\n    color: white;\n    padding: 0.5rem 1rem;\n    border-radius: 2rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n  }\n  \n  .likeButton {\n    position: absolute;\n    right: 1rem;\n    top: 1rem;\n    background: rgba(255, 255, 255, 0.9);\n    border: none;\n    border-radius: 50%;\n    width: 2.5rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n  }\n  \n  .likeButton:hover {\n    transform: scale(1.1);\n  }\n  \n  .heartIcon {\n    color: #e74c3c;\n  }\n  \n  .cardContent {\n    padding: 1.5rem;\n  }\n  \n  .authorInfo {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1rem;\n  }\n  \n  .author {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n  }\n  \n  .avatarCircle {\n    width: 2.5rem;\n    height: 2.5rem;\n    background: #f0f0f0;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 600;\n    color: #666;\n  }\n  \n  .authorName {\n    font-weight: 500;\n    color: #fff2f2;\n  }\n  \n  .date {\n    color: #ffffff;\n    font-size: 0.875rem;\n  }\n  \n  .cardTitle {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 0.75rem;\n    line-height: 1.4;\n  }\n  \n  .cardDescription {\n    color: #fff9f9;\n    line-height: 1.6;\n    margin-bottom: 1rem;\n  }\n  \n  .authorSignature {\n    display: block;\n    color: #b10b0b;\n    font-size: 0.875rem;\n    font-style: italic;\n  }\n  \n  @media (max-width: 768px) {\n    .hero {\n      padding: 3rem 1rem;\n    }\n    \n    .heroTitle {\n      font-size: 2rem;\n    }\n    \n    .blogGrid {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .hero {\n      padding: 2rem 1rem;\n    }\n    \n    .heroTitle {\n      font-size: 1.5rem;\n    }\n    \n    .cardContent {\n      padding: 1rem;\n    }\n  }\n  .learnMore {\n    color: #e41138;\n    font-weight: 500;\n    cursor: pointer;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CategoryBlog_container__JpvFl`,
	"hero": `CategoryBlog_hero__oelPj`,
	"heroTitle": `CategoryBlog_heroTitle__TTRi8`,
	"blogGrid": `CategoryBlog_blogGrid__xbF8v`,
	"blogCard": `CategoryBlog_blogCard__5xJiA`,
	"imageWrapper": `CategoryBlog_imageWrapper__eUYz8`,
	"cardImage": `CategoryBlog_cardImage__oQ5Nz`,
	"category": `CategoryBlog_category__NPECS`,
	"likeButton": `CategoryBlog_likeButton__Q4PLA`,
	"heartIcon": `CategoryBlog_heartIcon__LmiWk`,
	"cardContent": `CategoryBlog_cardContent__b4UYt`,
	"authorInfo": `CategoryBlog_authorInfo__BgyvL`,
	"author": `CategoryBlog_author__doFCK`,
	"avatarCircle": `CategoryBlog_avatarCircle__hYx99`,
	"authorName": `CategoryBlog_authorName__IN5J4`,
	"date": `CategoryBlog_date__XqXit`,
	"cardTitle": `CategoryBlog_cardTitle__OYGIO`,
	"cardDescription": `CategoryBlog_cardDescription__GkpyW`,
	"authorSignature": `CategoryBlog_authorSignature__8QpLa`,
	"learnMore": `CategoryBlog_learnMore__cMzwZ`
};
export default ___CSS_LOADER_EXPORT___;
